export default __webpack_public_path__ + "static/media/logo.dd34b7f5.png";